import { GtmAiContentImpressionType } from '~/modules/analytics/gtmEventTypes/gtmAiContentImpressionType';
import { GtmAiRelatedSearchClickType } from '~/modules/analytics/gtmEventTypes/gtmAiRelatedSearchClickType';
import { GtmAiSearchType } from '~/modules/analytics/gtmEventTypes/gtmAiSearchType';
import { GtmCarouselClickType } from '~/modules/analytics/gtmEventTypes/gtmCarouselClickType';
import { GtmHeaderNavLinkClickType } from '~/modules/analytics/gtmEventTypes/gtmHeaderNavLinkClickType';
import { GtmSortClickType } from '~/modules/analytics/gtmEventTypes/gtmSortClickType';
import { GtmTryButtonClickType } from '~/modules/analytics/gtmEventTypes/gtmTryButtonClickType';
import { GtmAiOverviewCardClickType } from './gtmAiOverviewCardClickType';
import { GtmAiOverviewFeedbackClickType } from './gtmAiOverviewFeedbackClickType';
import { GtmButtonClickType } from './gtmButtonClickType';
import { GtmCustomExperimentType } from './gtmCustomExperimentType';
import { GtmEventType } from './gtmEventType';
import { GtmReviewClickType } from './gtmReviewClickType';
import { GtmFilterClickType } from './gtmFilterClickType';
import { GtmFilterSearchType } from './gtmFilterSearchType';
import { GtmFormCompletionType } from './gtmFormCompletionType';
import { GtmInlineSuggestionSearchType } from './gtmInlineSuggestionSearchType';
import { GtmLinkClickType } from './gtmLinkClickType';
import { GtmListingDetailClickType } from './gtmListingDetailClickType';
import { GtmLoginNavClickType } from './gtmLoginNavClickType';
import { GtmLoginType } from './gtmLoginType';
import { GtmNavLinkClickType } from './gtmNavLinkClickType';
import { GtmOrgPickerClickType } from './gtmOrgPickerClickType';
import { GtmPageLevelType } from './gtmPageLevelType';
import { GtmPlatformFilterClickType } from './gtmPlatformFilterClickType';
import { GtmSearchClickType } from './gtmSearchClickType';
import { GtmSearchType } from './gtmSearchType';
import { GtmSignupType } from './gtmSignupType';
import { GtmAiAssetDetailSearchType } from './gtmAiAssetDetailSearchType';
import { GtmPluginEngagementType } from './gtmPluginEngagementType';
import { GtmSkillEngagementType } from './gtmSkillEngagementType';
import { GtmTileClickType } from './gtmTileClickType';
import { GtmTileViewType } from './gtmTileViewType';

export class GtmEventTypeFactory {
    gtmHandlers: GtmEventType[] = [
        new GtmReviewClickType(),
        new GtmFormCompletionType(),
        new GtmAiOverviewCardClickType(),
        new GtmAiContentImpressionType(),
        // MUST precede GtmSearchType — both match ANALYTICS_SEARCH_DONE but this
        // handler narrows by `searchSource=aiRelatedSearchPill`.
        new GtmAiRelatedSearchClickType(),
        new GtmAiSearchType(),
        // AI Asset detail handlers must precede the generic tile/button/tab/filter handlers.
        // Their predicates require an explicit feature marker, so ordinary listing/search events
        // continue through the existing handlers below.
        new GtmSkillEngagementType(),
        new GtmPluginEngagementType(),
        new GtmAiAssetDetailSearchType(),
        new GtmTileViewType(),
        new GtmTileClickType(),
        new GtmPlatformFilterClickType(),
        new GtmButtonClickType(),
        new GtmPageLevelType(),
        new GtmHeaderNavLinkClickType(),
        new GtmNavLinkClickType(),
        new GtmLinkClickType(),
        new GtmLoginType(),
        new GtmSignupType(),
        new GtmLoginNavClickType(),
        new GtmCustomExperimentType(),
        new GtmListingDetailClickType(),
        new GtmFilterClickType(),
        // Must sit before GtmSearchType — both match ANALYTICS_SEARCH_DONE
        // + type: 'keyword'; this one narrows further on searchSource === 'inlineSuggestion'.
        new GtmInlineSuggestionSearchType(),
        new GtmSearchType(),
        new GtmSearchClickType(),
        new GtmFilterSearchType(),
        new GtmSortClickType(),
        new GtmTryButtonClickType(),
        new GtmCarouselClickType(),
        new GtmOrgPickerClickType(),
        new GtmAiOverviewFeedbackClickType(),
    ];

    // Returns the FIRST handler whose canHandle() matches — order in gtmHandlers is significant.
    // A handler added earlier with an overlapping predicate will shadow a later one: e.g. if a new
    // handler above GtmOrgPickerClickType matched on topic ANALYTICS_CLICK without also narrowing by
    // elementType, it would swallow the org-picker events and they'd silently stop reaching GA4.
    // Keep specific-elementType handlers (like GtmOrgPickerClickType) ahead of any broad topic-only
    // matcher, or make every predicate mutually exclusive.
    // @ts-expect-error * Automated Type Error Fix
    getEventTypeHandler(event): GtmEventType {
        // @ts-expect-error * Automated Type Error Fix
        return this.gtmHandlers.find((handler) => handler.canHandle(event));
    }
}
